import { lazy } from "react";
const InvalidAttendance = lazy(() => import("./InvalidAttendance"));

const InvalidAttendanceRoutes = [
  {
    path: "/invalid-attendance",
    component: InvalidAttendance
  }
];

export default InvalidAttendanceRoutes;
